const getters = {
	auth: state => state.auth
}

export default getters